import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Tooltip } from "@mui/material";
import "./downloadBar.css";
import { downloadBar } from "../../types/types";
import SandClockUrl from "../../assets/gif/sandClock.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faXmark,faChevronUp, faChevronDown,faRotate} from "@fortawesome/free-solid-svg-icons";
import downloadAllIcon from "../../assets/image/svg/downloadAll.svg";
import { ConfirmationPopUp } from "./confirmationPopUp";
import { TranslationEnum, usePortalTranslation,} from "../../providers/TranslationProvider";
import {setShowDownload,addCancelDownload,setDownloadCount,removeDownload, showCancelPopup,addRetryDownload} from "../../stateManagement/actions/downloadBarActions";
import Draggable from "react-draggable"


const DownloadBar = (props: downloadBar) => {
  const [dropdown, setDropdown] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [isDragging, setIsDragging] = useState<boolean>(false);
 
  const { translate } = usePortalTranslation();
  const cancelPopup = useSelector((state: any) => state.downloadBarReducer.cancelPopup);
  
  const dispatch = useDispatch();

  function closeModal() {
    dispatch(setShowDownload(false));
  }

  function resetDownload(id: string) {
    dispatch(addRetryDownload(id));
  }
  function removeWordReport(name:string){
    const words = name.trim().split(" ");
      if (words[words.length - 1].toLowerCase() === "report"){
      words.pop();
     }
    return words.join(" ");
  }

   const handleDragStart = () => {
    setIsDragging(true);
  };
  const handleDragStop = () => {
    setIsDragging(false);
  };
  const removedDownload = (id: string) => {
    dispatch(addCancelDownload(id));
    dispatch(removeDownload(id));
    dispatch(setDownloadCount(-1));
  };
  



  return (
 
    <div>
      <Grid className="grid" md={6} lg={3} sm={12}>
        <ConfirmationPopUp
          message={translate(
            TranslationEnum.common_portal,
            "Are you sure you want to cancel the download"
          )}
          openConfirmModal={cancelPopup}
          successMethod={() => {
            removedDownload(selectedId);
          }}
          setOpenConfirmModal={
            ((value: boolean) =>
              dispatch(showCancelPopup(value))) as React.Dispatch<
              React.SetStateAction<boolean>
            >
          }
        />
      </Grid>
     
      <Draggable onStart={handleDragStart}
        onDrag={() => setIsDragging(true)}
        onStop={handleDragStop}
      bounds={(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;
      
 
    const horizontalLimit = width > 1440 ? -905 : -780;  
    const verticalLimit = height > 900 ? -685 : -610;
    return props.isPasswordSet
      ? { left: horizontalLimit, top: verticalLimit, right: 0, bottom: 0 }
      : { left: horizontalLimit, top: 0, right: 0, bottom: height > 900 ? 675 : 600 };
  })()}>

      <div  className={
      (props.isPasswordSet
        ? "download-bar-container-config"
        : "download-bar-container") +
      (isDragging ? " dragging-cursor" : "")
    }>
        <div className="download-bar-header">
          <div className="download-bar-header-left">  
            <img
              src={downloadAllIcon}
              alt="Download All Icon"
              className="download-icon-bar"
            />
            <h3 className="download-count">
              {translate(
                TranslationEnum.common_portal,
                `${props.downloadCount}`
              )}
              {props.downloadCount > 1 ? (
                <span className="download-message">
                  {" "}
                  {translate(
                    TranslationEnum.common_portal,
                    "reports are being generated"
                  )}
                </span>
              ) : (
                <span className="download-message">
                  {" "}
                  {translate(
                    TranslationEnum.common_portal,
                    "report is being generated"
                  )}
                </span>
              )}
            </h3>
          </div>
          <div className="download-bar-header-right">
            <div
              className="icon-container"
              onClick={() => setDropdown((prev) => !prev)}
            >
              <FontAwesomeIcon
                icon={dropdown ? faChevronUp : faChevronDown}
                className="icon"
              />
            </div>

            <div className="icon-container" onClick={closeModal}>
              <FontAwesomeIcon className="icon" icon={faXmark} />
            </div>
          </div>
        </div>
        {dropdown && (
          <div className="download-progress-box">
            {[...props.downloads].reverse().map((item) => {
              return (
                <div key={item.id} className="download-item">
                  <div className="download-item-title">
                    <div className="download-item-name">
                      {translate(
                        TranslationEnum.common_portal,
                        removeWordReport(item.name).toLocaleUpperCase() ?? ""
                      )}
                    </div>
                    <div className="download-records">
                      {translate(
                        TranslationEnum.common_portal,
                        `${item.totalRecordsCount} Records`
                      )}
                    </div>
                  </div>

                  {item.statusList.length === 0 ||
                  item.statusList.some((status) => status === "INPROGRESS") ? (
                    <div className="cancel-comp">
                       <img
                        src={SandClockUrl}
                        alt="Loading"
                        className="loading-spinner"
                        />
                      <button
                        className="download-cancel-btn"
                        onClick={() => {
                          setSelectedId(item.id ?? "");
                          dispatch(showCancelPopup(true));
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="failed-comp">
                      <Tooltip title="Retry download">
                        <span
                          className="retry"
                          onClick={() => {
                            resetDownload(item.id);
                          }}
                        >
                          <FontAwesomeIcon
                            className="retry-icon"
                            icon={faRotate}
                          />
                        </span>
                      </Tooltip>
                      <button
                        className="download-failed-btn"
                        disabled
                      >
                        Failed
                      </button>
                      
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
      </Draggable>
      
    </div>
 
  );
};

export default DownloadBar;
